import React, { useEffect } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { MicIcon } from "../../Common/Icons";
import "./Speech.scss";
import styled from "styled-components";

const SpeechArea = styled.div`
  height: ${(props) => props.inputHeight};
  line-height: ${(props) => props.inputHeight};

  button {
    height: ${(props) => props.inputHeight};
  }
  &.active {
    .bn-speech__trigger > svg {
      fill: ${(props) => props.primaryColor};
    }
  }
  span {
    background: ${(props) => props.primaryColor};
  }
`;

function SpeechComponent({ onText = () => {}, onFinish = () => {}, options }) {
  const config = Object.entries(options)
    // ignore undefined
    .filter(([option, value]) => value !== undefined)
    // merge options with default
    .reduce(
      (obj, [option, value]) => {
        obj[option] = value;
        return obj;
      },
      {
        speech_button_label: <MicIcon />,
        speech_listening_label: <span>Ouvindo...</span>,
        speech_permission_label: `Autorize o microfone`,
        speech_denied_label: `Sem acesso ao microfone`,
        speech_unsupported_label: <div>Sem suporte</div>,
        speech_language: `pt-BR`,
        speech_interim: false,
        speech_continuous: false,
        speech_hold_to_talk: false,
      }
    );

  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
    isMicrophoneAvailable,
  } = useSpeechRecognition();

  //   listening controls
  const startListening = () => {
    resetTranscript();

    SpeechRecognition.startListening({
      continuous: config.speech_continuous,
      language: config.speech_language,
      interimResults: config.speech_interim,
    });
  };

  const stopListening = () => {
    window.setTimeout(() => SpeechRecognition.stopListening(), 300);
  };

  const toogleListening = () => {
    if (listening) stopListening();
    else startListening();
  };

  //   build control actions
  const getControlProps = () => {
    const controls = {};

    if (config.speech_hold_to_talk) {
      controls.onTouchStart = startListening;
      controls.onMouseDown = startListening;
      controls.onTouchEnd = stopListening;
      controls.onMouseUp = stopListening;
    } else {
      controls.onTouchStart = toogleListening;
      controls.onMouseDown = toogleListening;
    }

    return controls;
  };

  //   bind onFinish function to speechend event
  if (browserSupportsSpeechRecognition) {
    SpeechRecognition.getRecognition().onspeechend = () => onFinish(transcript);
  }

  //   call onText function every time transcript is updated
  useEffect(() => {
    onText(transcript);
  }, [transcript]);

  // browser do not support web speech
  if (!browserSupportsSpeechRecognition) {
    return null;
  }

  return (
    <SpeechArea
      className={`bn-speech ${
        listening
          ? `active`
          : !isMicrophoneAvailable
          ? `unavailable`
          : `standby`
      }`}
      {...options.customOptions}
    >
      <span className="bn-speech__listening">
        {config.speech_listening_label}
      </span>
      <button
        className="bn-speech__trigger"
        type="button"
        style={{
          fontSize: 19,
          cursor: "pointer",
        }}
        {...getControlProps()}
      >
        {config.speech_button_label}
      </button>
    </SpeechArea>
  );
}

export default SpeechComponent;
